import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import VCalendar from 'v-calendar'
import Notifications from '@kyvg/vue3-notification'
import 'v-calendar/style.css'
import permissionDirective from './directives/permission.js'

// EventBus - For global events
import mitt from 'mitt'
const emitter = mitt()

const app = createApp(App)
app.config.globalProperties.emitter = emitter
app.use(VCalendar, {})
app.use(Notifications)
app.use(store).use(router)
app.directive('permission', permissionDirective)
app.mount('#app')
